import React from 'react';
import PropTypes from 'prop-types';

const CustomIcon = ({
  fieldsValidated,
  className = 'custom-icon-container bi bi-check-circle-fill',
  fieldError = {},
  required,
}) => {
  if (fieldsValidated && required && Object.keys(fieldError).length === 0) {
    return <i className={className} />;
  }

  return null;
};

CustomIcon.propTypes = {
  fieldsValidated: PropTypes.bool,
  className: PropTypes.string,
  fieldError: PropTypes.object,
  required: PropTypes.bool,
};

export default CustomIcon;
